// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__kWeMG","imgText":"Projects_imgText__qj4tC","imgFromTop":"Projects_imgFromTop__qKttx"};